import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Grid, Row, Col} from 'react-bootstrap'
import OrdersList from './orders-list'
import OrderSearch from './orders-search'
import { getOrders } from '../../../actions/orders'
import PageTitle from '../../common/page-title/index'

import './styles.css'

class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderNumber: '',
      dateFrom: '',
      dateTo: '',
      status: ''
    };
  }

  componentWillMount() {
    this.props.dispatch(getOrders());
  }

  handleInputChange = (e) => {
    this.setState({orderNumber: e.target.value});
  };

  handleDateFromChange = (value) => {
    if(typeof value === 'object'){
      this.setState({dateFrom: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateFrom: ''});
    }
  };

  handleDateToChange = (value) => {
    if(typeof value === 'object'){
      this.setState({dateTo: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateTo: ''});
    }
  };

  handleStatusOrderChange = (e) => {
    this.setState({status: e.target.value});
  };

  handleSearch = () => {
    const {orderNumber, dateFrom, dateTo, status} = this.state;
    this.props.dispatch(getOrders(orderNumber, dateFrom, dateTo, status));
  };

  handleClear = () => {
    this.setState({
      orderNumber: '',
      dateFrom: '',
      dateTo: '',
      status: ''
    }, this.handleSearch);
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="orders">
        <PageTitle>Orders</PageTitle>

        <Row>
          <Col md={12}>
            <OrderSearch
              statusList={this.props.statusList}
              searchValue={this.state.orderNumber}
              statusOrderValue={this.state.status}
              dateFromValue={this.state.dateFrom}
              dateToValue={this.state.dateTo}
              onInputChange={this.handleInputChange}
              onDateFromChange={this.handleDateFromChange}
              onDateToChange={this.handleDateToChange}
              onStatusOrderChange={this.handleStatusOrderChange}
              onSearch={this.handleSearch}
              onClear={this.handleClear}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <OrdersList
              orders={this.props.orders}
              fetching={this.props.fetching}
              fetched={this.props.fetched}
            />
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.orders.list,
    statusList: state.orders.statusList,
    fetching: state.orders.fetching,
    fetched: state.orders.fetched
  };
};

export default connect(mapStateToProps)(Orders);


// WEBPACK FOOTER //
// ./src/components/admin/orders/index.jsx